export default __webpack_public_path__ + "static/media/lp-new-backfit-exercise-01.64a2d191.jpg";